import { axios } from '@/utils/request'

export default {
    create(tenant){
        return axios.post('/api/services/app/Tenant/Create',tenant)
    },
    update(tenant){
        return axios.put('/api/services/app/Tenant/Update',tenant)
    },
    delete(id){
        return axios.delete('/api/services/app/Tenant/Delete?Id='+id)
    },
    get(id){
        return axios.get('/api/services/app/Tenant/Get?Id='+id)
    },
    getAll(page){
        return axios.get('/api/services/app/Tenant/GetAll',{params:page})
    },
    getEditions(){
        return axios.get('/api/services/app/Edition/GetAll')
    },
    disabled(tenant){
        return axios.post('/api/services/app/Tenant/Disabled',tenant)
    },
    active(tenant){
        return axios.post('/api/services/app/Tenant/Active',tenant)
    },
    payment(pay){
        return axios.post('/api/services/app/Tenant/Payment',pay)
    },
    getPayments(tenant){
        return axios.get('/api/services/app/Tenant/GetPayments',{params:tenant})
    }
}